import Location from "../../images/contact-us/location.png";
import X from "../../images/xapp.png";
import Tiktok from "../../images/tiktok.png";
import IG from "../../images/instagram.png";
import FB from "../../images/facebook.png";
import { Link } from "react-router-dom";

function ContactFooter() {
  return (
    <div className="footer">
      <img src={Location} alt="location" />
      <div className="address1">
        <h2>
          Head office<br></br>289B Akin Olugbade Street, <br></br>Off Adeola
          Odeku, Victoria Island,<br></br> Lagos, Nigeria.
        </h2>
        <div className="cta">
          <p>View map</p>
          <div />
        </div>
      </div>
      <div className="address2">
        <h2>
          Abuja Office <br></br>Block T402 Rock City Estate, <br></br>Plot 1336
          Ibrahim Isiyaku Street,<br></br> Mabuchi, Abuja FCT Nigeria.
        </h2>
        <div className="cta">
          <p>View map</p>
          <div />
        </div>
      </div>
      <div className="socials">
        <Link to="https://twitter.com/brandone_tech">
          <img alt="socials" src={X} />
        </Link>
        <Link to="https://instagram.com/brandonetech">
          <img alt="socials" src={IG} />
        </Link>
        <Link to="https://www.facebook.com/BrandOneTecnologies/">
          <img alt="socials" src={FB} />
        </Link>
        <Link to="/">
          <img alt="socials" src={Tiktok} />
        </Link>
      </div>
    </div>
  );
}

export default ContactFooter;
